import mushroom from 'mushroomjs';

mushroom._defineAsyncResource({ name: "user", actions: { "findMany": { "clientCache": true }, "findById": { "clientCache": true }, "createOne": {}, "updatePartially": {}, "_raw_http_method_isOnline": {}, "_raw_http_method_register": {}, "_raw_http_method_registerSafePlaceUser": {}, "_raw_http_method_generateHashCode": {}, "_raw_http_method_getUserIdOrFetchAcsUser": {}, "_raw_http_method_requestOtp": {}, "_raw_http_method_validateOtp": {}, "_raw_http_method_validateOtp_v2": {}, "_raw_http_method_login_no_pass": {} }, views: {} });
mushroom._defineAsyncResource({ name: "user_tcqltt", actions: { "findMany": { "clientCache": true }, "findById": { "clientCache": true }, "createOne": {}, "updatePartially": {} }, views: {} });
mushroom._defineAsyncResource({ name: "profile", actions: { "findMany": { "clientCache": true }, "findById": { "clientCache": true }, "createOne": {}, "updatePartially": {} }, views: { "listSafePlaceUsersByPhoneNumber": {} } });
mushroom._defineAsyncResource({ name: "khach_du_lich", actions: { "findMany": { "clientCache": true }, "findById": { "clientCache": true }, "createOne": {}, "updatePartially": {} }, views: { "layHoTenTheoSoThe": {} } });
mushroom._defineAsyncResource({ name: "huong_dan_vien", actions: { "findMany": { "clientCache": true }, "findById": { "clientCache": true }, "createOne": {}, "updatePartially": {}, "_raw_http_method_finishSyncSession": {} }, views: {} });
mushroom._defineAsyncResource({ name: "so_truong", actions: { "findMany": { "clientCache": true }, "findById": { "clientCache": true }, "createOne": {}, "updatePartially": {} }, views: {} });
mushroom._defineAsyncResource({ name: "ngoai_ngu", actions: { "findMany": { "clientCache": true }, "findById": { "clientCache": true }, "createOne": {}, "updatePartially": {} }, views: {} });
mushroom._defineAsyncResource({ name: "quoc_tich", actions: { "findMany": { "clientCache": true }, "findById": { "clientCache": true }, "createOne": {}, "updatePartially": {} }, views: {} });
mushroom._defineAsyncResource({ name: "ms_khach_du_lich", actions: { "findMany": { "clientCache": true }, "findById": { "clientCache": true }, "_raw_http_method_register_ms_khachdulich": {} }, views: {} });
mushroom._defineAsyncResource({ name: "cong_ty_lu_hanh", actions: { "findMany": { "clientCache": true }, "findById": { "clientCache": true }, "createOne": {}, "updatePartially": {}, "_raw_http_method_saodanhgia": {} }, views: { "dashboard_getStatistics": {} } });
mushroom._defineAsyncResource({ name: "tour", actions: { "findMany": { "clientCache": true }, "findById": { "clientCache": true }, "createOne": {}, "updatePartially": {}, "deleteOne": {}, "_raw_http_method_confirmTour": {}, "_raw_http_method_removeKhachDuLich": {}, "_raw_http_method_importTourists": {}, "_raw_http_method_addTouristByCardCode": {} }, views: { "getPendingTours": {}, "getTourCountByTourGuideIds": {}, "dashboard_getTourGuideStatistics": {}, "dashboard_getTourCountStatistics": {} } });
mushroom._defineAsyncResource({ name: "phieu_dieu_tour", actions: { "findMany": { "clientCache": true }, "findById": { "clientCache": true }, "createOne": {}, "updatePartially": {}, "deleteOne": {}, "_raw_http_method_confirmPhieuDieuTour": {} }, views: {} });
mushroom._defineAsyncResource({ name: "nhom_phan_hoi", actions: { "findMany": { "clientCache": true }, "findById": { "clientCache": true }, "createOne": {}, "updatePartially": {} }, views: {} });
mushroom._defineAsyncResource({ name: "phan_hoi", actions: { "findMany": { "clientCache": true }, "findById": { "clientCache": true }, "createOne": {}, "updatePartially": {}, "deleteOne": {}, "deleteMany": {} }, views: { "dashboard_getMonthCountStatistics": {}, "dashboard_getStatusStatistics": {}, "suggest_response_user": {} } });
mushroom._defineAsyncResource({ name: "nhom_thanh_phan_danh_gia", actions: { "findMany": { "clientCache": true }, "findById": { "clientCache": true }, "createOne": {}, "updatePartially": {} }, views: {} });
mushroom._defineAsyncResource({ name: "danh_gia", actions: { "findMany": { "clientCache": true }, "findById": { "clientCache": true }, "createOne": {}, "updatePartially": {}, "deleteOne": {} }, views: { "getStar": {}, "getSortableStar": {}, "getSortableStarTotal": {}, "getSortableStarForTourist": {}, "getSortableStarForTouristTotal": {}, "getSortableStarForSafePlace": {}, "getSortableStarForSafePlaceTotal": {}, "dashboard_getTourGuideStarStatistics": {}, "dashboard_getCompanyStarStatistics": {}, "dashboard_getTouristRatingForCompanyStatistics": {} } });
mushroom._defineAsyncResource({ name: "danh_muc_tin", actions: { "findMany": { "clientCache": true }, "findById": { "clientCache": true }, "createOne": {}, "updatePartially": {} }, views: {} });
mushroom._defineAsyncResource({ name: "tin_tuc", actions: { "findMany": { "clientCache": true }, "findById": { "clientCache": true }, "createOne": {}, "updatePartially": {} }, views: {} });
mushroom._defineAsyncResource({ name: "dich_vu_chat_luong_cao", actions: { "findMany": { "clientCache": true }, "findById": { "clientCache": true }, "createOne": {}, "updatePartially": {} }, views: {} });
mushroom._defineAsyncResource({ name: "co_so_luu_tru", actions: { "findMany": { "clientCache": true }, "findById": { "clientCache": true }, "createOne": {}, "updateOne": {}, "updatePartially": {} }, views: {} });
mushroom._defineAsyncResource({ name: "cslt_xep_hang", actions: { "findMany": { "clientCache": true }, "findById": { "clientCache": true }, "createOne": {}, "updatePartially": {} }, views: {} });
mushroom._defineAsyncResource({ name: "cslt_loai_hinh", actions: { "findMany": { "clientCache": true }, "findById": { "clientCache": true }, "createOne": {}, "updatePartially": {} }, views: {} });
mushroom._defineAsyncResource({ name: "cslt_dich_vu", actions: { "findMany": { "clientCache": true }, "findById": { "clientCache": true }, "createOne": {}, "updatePartially": {} }, views: {} });
mushroom._defineAsyncResource({ name: "diem_den_an_toan", actions: { "findMany": { "clientCache": false }, "findById": { "clientCache": false }, "createOne": {}, "updatePartially": {}, "deleteOne": {}, "_raw_http_method_import_ddat_excel": {}, "_raw_http_method_search": {}, "_raw_http_method_update_tinh_id": {}, "_raw_http_method_update_uu_dai": {} }, views: { "search_ddat": {}, "total_search_ddat": {}, "total_ddat_to_now_group_by_province": {}, "total_ddat_by_day_group_by_province": {}, "total_ddat_to_now_group_by_type": {}, "total_ddat_by_day_group_by_type": {}, "total_ddat_group_by_day": {}, "declared_calendar": {}, "declared_status_calendar": {}, "search_sms":{} } });
mushroom._defineAsyncResource({ name: "diem_den_an_toan_check_in", actions: { "findMany": { "clientCache": true }, "findById": { "clientCache": true }, "createOne": {}, "_raw_http_method_getKhachDuLich": {}, }, views: {} });
mushroom._defineAsyncResource({ name: "canh_bao_hang_ngay", actions: { "findMany": { "clientCache": true }, "findById": { "clientCache": true }, "createOne": {}, "updatePartially": {} }, views: {} });
mushroom._defineAsyncResource({ name: "chuong_trinh", actions: { "findMany": { "clientCache": true }, "findById": { "clientCache": true }, "createOne": {}, "updatePartially": {} }, views: {} });
mushroom._defineAsyncResource({ name: "dang_ky_chuong_trinh", actions: { "findMany": { "clientCache": true }, "findById": { "clientCache": true }, "createOne": {}, "deleteOne": {}, "_raw_http_method_duyet_thanh_tich_huy_hieu": {} }, views: {} });
mushroom._defineAsyncResource({ name: "huy_hieu", actions: { "findMany": { "clientCache": true }, "findById": { "clientCache": true }, "createOne": {}, "updatePartially": {} }, views: {} });
mushroom._defineAsyncResource({ name: "thanh_tich_huy_hieu", actions: { "findMany": { "clientCache": true }, "findById": { "clientCache": true }, "createOne": {}, "deleteOne": {}, "updatePartially": {}, "_raw_http_method_view_huy_hieu_hdv": {} }, views: {} });
mushroom._defineAsyncResource({ name: "location", actions: { "findMany": { "clientCache": true }, "createOne": {} }, views: {} });
mushroom._defineAsyncResource({ name: "vung_dich", actions: { "findById": { "clientCache": true }, "findMany": { "clientCache": true }, "createOne": {}, "updatePartially": {}, "deleteOne": {} }, views: {} });
mushroom._defineAsyncResource({ name: "chat", actions: { "findMany": {}, "updateOne": {}, "deleteOne": {} }, views: { "getLatestMessages": {}, "getLatestRoomMessages": {} } });
mushroom._defineAsyncResource({ name: "notification_log", actions: { "findMany": {}, "findById": {}, "createOne": {}, "deleteOne": {}, "deleteMany": {} }, views: {} });
mushroom._defineAsyncResource({ name: "notification", actions: { "findMany": {}, "findById": {}, "createOne": {}, "updatePartially": {}, "deleteOne": {}, "deleteMany": {} }, views: {} });
mushroom._defineAsyncResource({ name: "notification_status", actions: { "findMany": {}, "createOne": {}, "updatePartially": {} }, views: {} });
mushroom._defineAsyncResource({ name: "device", actions: { "findMany": { "clientCache": true }, "createOne": {}, "_raw_http_method_delete_by_device_id": {}, "_raw_http_method_delete_by_user": {}, "_raw_http_method_save_device": {} }, views: {} });
mushroom._defineAsyncResource({ name: "config", actions: { "findMany": { "clientCache": true }, "findById": { "clientCache": true }, "createOne": {}, "updatePartially": {} }, views: {} });
mushroom._defineAsyncResource({ name: "version", actions: { "findById": { "clientCache": true }, "findMany": { "clientCache": true }, "updatePartially": {} }, views: {} });
mushroom._defineAsyncResource({ name: "province", actions: { "findMany": { "clientCache": true }, "findById": { "clientCache": true } }, views: {} });
mushroom._defineAsyncResource({ name: "district", actions: { "findMany": { "clientCache": true }, "findById": { "clientCache": true } }, views: {} });
mushroom._defineAsyncResource({ name: "commune", actions: { "findMany": { "clientCache": true }, "findById": { "clientCache": true } }, views: {} });
mushroom._defineAsyncResource({ name: "file", actions: { "findMany": { "clientCache": true }, "findById": { "clientCache": true } }, views: {} });
mushroom._defineAsyncResource({ name: "dashboard", actions: {}, views: { "ddat_count": {}, "ddat_count_daily_declared": {}, "ddat_statistic_daily": {}, "stats_2012_total_register_count": {}, "stats_2012_total_declared_count": {}, "stats_2012_total_regular_count": {}, "stats_2012_total_safety_status_count": {}, "stats_2012_register_list": {}, "stats_2012_declared_list": {}, "stats_2012_undeclared_list": {}, "stats_2012_safety_status_list": {}, "ddat_total_declared_province_count": {}, "stats_total_declared_provinces": {} } });
mushroom._defineAsyncResource({ name: "user_qlddat", actions: { "_raw_http_method_generateUser": {} }, views: {} });
mushroom._defineAsyncResource({ name: "foreigner_qr", actions: { "findMany": { "clientCache": true }, "findById": { "clientCache": true } }, views: {} });
mushroom._defineAsyncResource({ name: "foreigner", actions: { "findMany": { "clientCache": true }, "findById": { "clientCache": true } }, views: {} });
mushroom._defineAsyncResource({ name: "danh_gia_log", actions: { "findMany": { "clientCache": true }, "findById": { "clientCache": true } }, views: {} });
mushroom._defineAsyncResource({ name: "quang_cao", actions: { "findById": { "clientCache": true }, "findMany": { "clientCache": true }, "createOne": {}, "updatePartially": {}, "deleteOne": {} }, views: {} });
mushroom._defineAsyncResource({ name: "user_svhtt", actions: { "findById": { "clientCache": true }, "findMany": { "clientCache": true }, "createOne": {}, "updatePartially": {} }, views: {} });
mushroom._defineAsyncResource({ name: "user_pvhtt", actions: { "findById": { "clientCache": true }, "findMany": { "clientCache": true }, "createOne": {}, "updatePartially": {} }, views: {} });


function toQueryString(obj, path) {
    if (obj === null || obj === undefined || typeof obj == "function")
        return "";

    if (typeof obj == "string" || typeof obj == "number" || typeof obj == "boolean")
        return obj;

    if (Array.isArray(obj))
        return obj.map(function(item) {
            return toQueryString(item, path);
        }).join(",");

    var arr = [];
    for (var m in obj) {
        if (!obj.hasOwnProperty(m))
            continue;

        var key = (path ? path : "") + m;
        arr.push(key + "=" + toQueryString(obj[m], key));
    }
    return arr.join("&");
}


mushroom.tour.importTouristsAsync = function(body, parameters) {
    var p = mushroom.__createAsyncRestFunction({
        resource: "tour",
        method: "POST",
        blankBody: false,
        headers: {
            "X-HTTP-Method-Override": "importTourists"
        },
        //rootApiUrl: rootApiUrl,
        url: mushroom._fnGetRootApiUrl() + "tours/importTourists?" + toQueryString(parameters),
        connection: mushroom.tour,
        name: "importTourists",
        clearCache: true
    })(body);
    return p;
};

mushroom.tour.removeKhachDuLichAsync = function(body, parameters) {
    var p = mushroom.__createAsyncRestFunction({
        resource: "tour",
        method: "POST",
        blankBody: false,
        headers: {
            "X-HTTP-Method-Override": "removeKhachDuLich"
        },
        //rootApiUrl: rootApiUrl,
        url: mushroom._fnGetRootApiUrl() + "tours/removeKhachDuLich?" + toQueryString(parameters),
        connection: mushroom.tour,
        name: "removeKhachDuLich",
        clearCache: true
    })(body);
    return p;
};

mushroom.cong_ty_lu_hanh.saodanhgiaAsync = function(body) {
    var p = mushroom.__createAsyncRestFunction({
        resource: "cong_ty_lu_hanh",
        method: "POST",
        blankBody: false,
        headers: {
            "X-HTTP-Method-Override": "saodanhgia"
        },
        //rootApiUrl: rootApiUrl,
        url: mushroom._fnGetRootApiUrl() + "cong_ty_lu_hanhs/saodanhgia",
        connection: mushroom.cong_ty_lu_hanh,
        name: "saodanhgia",
        clearCache: true
    })(body);
    return p;
};
// mushroom.tour.removeKhachDuLichAsync = function (tourId, userId) {
//     var rootApiUrl = mushroom.$using();
//     return mushroom.__createAsyncRestFunction({
//         name: "tour.removeKhachDuLich",
//         rootApiUrl: rootApiUrl,
//         method: "GET",
//         headers: {
//             "X-HTTP-Method-Override": "removeKhachDuLich"
//         },
//         blankBody: true,
//         url: mushroom.$using() + "tours/removeKhachDuLich?tourId=" + tourId + "&userId=" + userId
//     })();
// };

mushroom.$auth.checkActiveAsync = function(account) {
    return mushroom.__createAsyncRestFunction({
        name: "$auth.checkActiveAsync",
        // rootApiUrl: rootApiUrl,
        method: "POST",
        blankBody: false,
        url: mushroom._fnGetRootApiUrl() + "onelink/checkActive"
    })({
        account: account
    });
};

//Viết thêm - nsthieu
mushroom.user.registerAsync = function(body, parameters) {
    var p = mushroom.__createAsyncRestFunction({
        resource: "user",
        method: "POST",
        blankBody: false,
        headers: {
            "X-HTTP-Method-Override": "register"
        },
        //rootApiUrl: rootApiUrl,
        url: mushroom._fnGetRootApiUrl() + "users/register?" + toQueryString(parameters),
        connection: mushroom.user,
        name: "register",
        clearCache: true
    })(body);
    return p;
};
mushroom.user.registerSafePlaceUserAsync = function(body, parameters) {
    var p = mushroom.__createAsyncRestFunction({
        resource: "user",
        method: "POST",
        blankBody: false,
        headers: {
            "X-HTTP-Method-Override": "registerSafePlaceUser"
        },
        //rootApiUrl: rootApiUrl,
        url: mushroom._fnGetRootApiUrl() + "users/registerSafePlaceUser?" + toQueryString(parameters),
        connection: mushroom.user,
        name: "registerSafePlaceUser",
        clearCache: true
    })(body);
    return p;
};

mushroom.diem_den_an_toan.import_ddat_excelAsync = function(body, parameters) {
    var p = mushroom.__createAsyncRestFunction({
        resource: "diem_den_an_toan",
        method: "POST",
        blankBody: false,
        headers: {
            "X-HTTP-Method-Override": "import_ddat_excel"
        },
        //rootApiUrl: rootApiUrl,
        url: mushroom._fnGetRootApiUrl() + "diem_den_an_toans/import_ddat_excel?" + toQueryString(parameters),
        connection: mushroom.diem_den_an_toan,
        name: "import_ddat_excel",
        clearCache: true
    })(body);
    return p;
};

mushroom.diem_den_an_toan.update_uu_daiAsync = function (body, parameters) {
  var p = mushroom.__createAsyncRestFunction({
    resource: "diem_den_an_toan",
    method: "POST",
    blankBody: false,
    headers: {
      "X-HTTP-Method-Override": "update_uu_dai",
    },
    //rootApiUrl: rootApiUrl,
    url:
      mushroom._fnGetRootApiUrl() + "diem_den_an_toans/update_uu_dai",
    connection: mushroom.diem_den_an_toan,
    name: "update_uu_dai",
    clearCache: true,
  })(body);
  return p;
};


mushroom.user.getUserIdOrFetchAcsUserAsync = function(body, parameters) {
    var p = mushroom.__createAsyncRestFunction({
        resource: "user",
        method: "POST",
        blankBody: false,
        headers: {
            "X-HTTP-Method-Override": "getUserIdOrFetchAcsUser"
        },
        //rootApiUrl: rootApiUrl,
        url: mushroom._fnGetRootApiUrl() + "users/getUserIdOrFetchAcsUser?" + toQueryString(parameters),
        connection: mushroom.user,
        name: "getUserIdOrFetchAcsUser",
        clearCache: true
    })(body);
    return p;
};

//end

mushroom.user.generateHashCodeAsync = function(body, parameters) {
    var p = mushroom.__createAsyncRestFunction({
        resource: "user",
        method: "POST",
        blankBody: false,
        headers: {
            "X-HTTP-Method-Override": "generateHashCode"
        },
        //rootApiUrl: rootApiUrl,
        url: mushroom._fnGetRootApiUrl() + "users/generateHashCode?" + toQueryString(parameters),
        connection: mushroom.user,
        name: "generateHashCode",
        clearCache: true
    })(body);
    return p;
};

mushroom.tour.addTouristByCardCodeAsync = function(body, parameters) {
    var p = mushroom.__createAsyncRestFunction({
        resource: "tour",
        method: "POST",
        blankBody: false,
        headers: {
            "X-HTTP-Method-Override": "addTouristByCardCode"
        },
        // rootApiUrl: rootApiUrl,
        url: mushroom._fnGetRootApiUrl() + "tours/addTouristByCardCode?" + toQueryString(parameters),
        connection: mushroom.tour,
        name: "addTouristByCardCode",
        clearCache: true
    })(body);
    return p;
};

mushroom.dang_ky_chuong_trinh.duyet_thanh_tich_huy_hieuAsync = function(body, parameters) {
    var p = mushroom.__createAsyncRestFunction({
        resource: "dang_ky_chuong_trinh",
        method: "POST",
        blankBody: false,
        headers: {
            "X-HTTP-Method-Override": "duyet_thanh_tich_huy_hieu"
        },
        //rootApiUrl: rootApiUrl,
        url: mushroom._fnGetRootApiUrl() + "dang_ky_chuong_trinhs/duyet_thanh_tich_huy_hieu",
        connection: mushroom.dang_ky_chuong_trinh,
        name: "duyet_thanh_tich_huy_hieu",
        clearCache: true
    })(body);
    return p;
};

mushroom.ms_khach_du_lich.register_ms_khachdulichAsync = function(body, parameters) {
    var p = mushroom.__createAsyncRestFunction({
        resource: "ms_khach_du_lich",
        method: "POST",
        blankBody: false,
        headers: {
            "X-HTTP-Method-Override": "register_ms_khachdulich"
        },
        //rootApiUrl: rootApiUrl,
        url: mushroom._fnGetRootApiUrl() + "ms_khach_du_lichs/register_ms_khachdulich",
        connection: mushroom.ms_khach_du_lich,
        name: "register_ms_khachdulich",
        clearCache: true
    })(body);
    return p;
};

mushroom.phan_hoi.updateStatusAsync = function(body, parameters) {
    var p = mushroom.__createAsyncRestFunction({
        resource: "phan_hoi",
        method: "POST",
        blankBody: false,
        headers: {
            "X-HTTP-Method-Override": "updateStatus"
        },
        //rootApiUrl: rootApiUrl,
        url: mushroom._fnGetRootApiUrl() + "phan_hois/updateStatus",
        connection: mushroom.phan_hoi,
        name: "updateStatus",
        clearCache: true
    })(body);
    return p;
};
mushroom.diem_den_an_toan.searchSMSAsync = function(body, parameters) {
    var p = mushroom.__createAsyncRestFunction({
        resource: "diem_den_an_toan",
        method: "POST",
        blankBody: false,
        headers: {
            "X-HTTP-Method-Override": "searchSMS"
        },
        //rootApiUrl: rootApiUrl,
        url: mushroom._fnGetRootApiUrl() + "diem_den_an_toans/searchSMS",
        connection: mushroom.diem_den_an_toan,
        name: "searchSMS",
        clearCache: true
    })(body);
    return p;
};

mushroom.user.getAccountByEmailAsync = function(body, parameters) {
    var p = mushroom.__createAsyncRestFunction({
        resource: "user",
        method: "POST",
        blankBody: false,
        headers: {
            "X-HTTP-Method-Override": "getAccountByEmail"
        },
        //rootApiUrl: rootApiUrl,
        url: mushroom._fnGetRootApiUrl() + "users/getAccountByEmail",
        connection: mushroom.user,
        name: "getAccountByEmail",
        clearCache: true
    })(body);
    return p;
};

//diem_den_an_toan_check_in
mushroom.diem_den_an_toan_check_in.getKhachDuLichAsync = function(body) {
  var p = mushroom.__createAsyncRestFunction({
      resource: "diem_den_an_toan_check_in",
      method: "POST",
      blankBody: false,
      headers: {
        "X-HTTP-Method-Override": "getKhachDuLich"
      },
      //rootApiUrl: rootApiUrl,
      url: mushroom._fnGetRootApiUrl() + "diem_den_an_toan_check_ins/getKhachDuLich",
      connection: mushroom.diem_den_an_toan_check_in,
      name: "getKhachDuLich",
      clearCache: true
  })(body);
  return p;
};

mushroom.$using(window.MyConfig.hostApi);
export default mushroom;
